import { Injectable } from '@angular/core';

import { MobileConfirmationNotificationClientConfig } from '@frontend/sports/common/client-config-data-access';
import { ModalDialogService } from '@frontend/sports/modal/feature';
import { UserService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';

import { LocalStorageService } from '../common/local-storage.service';
import { IUiRootState, uiStateSelector } from '../ui-manager/ui-manager.state';
import { UiStates } from '../ui-manager/ui-states.enum';
import { MobileNumberAcknowledgement, UpdateMobileNumber } from './model/update-mobile-number.model';
import { UpdateMobileNumberComponent } from './update-mobile-number.component';

@Injectable({ providedIn: 'root' })
export class UpdateMobileNumberService {
    private isEnabled: boolean;
    private confirmationInterval: number;
    uiStates: UiStates[];

    constructor(
        private modalDialogService: ModalDialogService,
        private localStorageService: LocalStorageService,
        private userService: UserService,
        private mobileConfirmationNotificationsConfig: MobileConfirmationNotificationClientConfig,
        private store: Store<IUiRootState>,
    ) {
        this.store.select(uiStateSelector).subscribe((ui) => (this.uiStates = ui.states));

        this.mobileConfirmationNotificationsConfig.whenReady.subscribe(() => {
            this.isEnabled = this.mobileConfirmationNotificationsConfig.isEnabled;
            this.confirmationInterval = this.mobileConfirmationNotificationsConfig.confirmationIntervalMilliseconds;
        });
    }

    launchMobileNumberConfirmationPopup(): void {
        this.modalDialogService.openDialog(UpdateMobileNumberComponent, {
            settings: {
                cssClass: UpdateMobileNumber.PopupIdentifier,
                showDialogHeader: false,
                hideCloseButton: true,
                isModalDialog: true,
                showCloseBtnText: true,
            },
        });
    }

    showMobileNumberConfirmation(): boolean {
        if (!this.isEnabled || this.uiStates.includes(UiStates.QuickBet)) {
            return false;
        }

        const mobileNumberAcknowledgement: MobileNumberAcknowledgement | null = this.localStorageService.getItemObject<MobileNumberAcknowledgement>(
            UpdateMobileNumber.StorageItemIdentifier,
        );

        if (!mobileNumberAcknowledgement) {
            return true;
        }

        const savedTime: number = mobileNumberAcknowledgement[this.userService.accountId!];
        if (!savedTime) {
            return true;
        }
        return this.isDifferenceExceedingTimespan(new Date(savedTime));
    }

    private isDifferenceExceedingTimespan(date: Date): boolean {
        const differenceInMillis = this.calculateTimeDifference(date);
        return differenceInMillis > this.confirmationInterval;
    }

    private calculateTimeDifference(date: Date): number {
        return Math.abs(new Date().getTime() - date.getTime());
    }
}
